import { render, staticRenderFns } from "./DetailChip.vue?vue&type=template&id=3a5fe3f8&scoped=true"
import script from "./DetailChip.vue?vue&type=script&lang=js"
export * from "./DetailChip.vue?vue&type=script&lang=js"
import style0 from "./DetailChip.vue?vue&type=style&index=0&id=3a5fe3f8&prod&lang=scss"
import style1 from "./DetailChip.vue?vue&type=style&index=1&id=3a5fe3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5fe3f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VListItemContent,VMenu})
